<div class="item">
    <div *ngIf="artifact.description" class="pb-2">
        <p [innerHTML]="getSafeHtml(artifact.description)"></p>
    </div>

    <div *ngIf="loading" class="text-center py-4">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="mt-2">Loading document...</p>
    </div>

    <div *ngIf="error" class="alert alert-danger">
        {{ error }}
    </div>

    <div #pdfContainer class="pdf-container" [class.hidden]="loading || error">
    </div>

    <div *ngIf="isDocumentReady() && !hasScrolledToEnd && !isReadOnly()" class="scroll-hint">
        <mat-icon>arrow_downward</mat-icon>
        <span>Scroll to the end of the document to continue</span>
    </div>

    <div class="acknowledge-section" *ngIf="isDocumentReady()">
        <mat-checkbox
            [(ngModel)]="acknowledged"
            [disabled]="!canAcknowledge()"
            (change)="onAcknowledgeChanged()">
            I have reviewed and acknowledge the contents of this document.
        </mat-checkbox>
        <p class="acknowledge-reason" *ngIf="!canAcknowledge()">{{ getAcknowledgeDisabledReason() }}</p>
    </div>
</div>
